/* 📦 LIBS */
import { Routes, Route, Navigate } from "react-router-dom";

/* 📄 PAGES */
import { ConfirmaEmail, Login, ResetPassword, AppMap } from "../Pages";

// Colocar todas as rotas NÃO autenticadas aqui dentro
function AuthRoutes(){
    return(
        <Routes>
            <Route path="/login" Component={Login} />
            <Route path="/map" Component={AppMap}/>
            <Route path="/perfil/confirmaemail/:token" Component={ConfirmaEmail} />
            <Route path="/perfil/reset-password/:token" Component={ResetPassword} />
            <Route path="*" element={<Navigate to={'/login'} state={{ from: window.location.pathname }}/>}/>
        </Routes>
    )
}

export default AuthRoutes;